
import parseFloatCz from '../common/parseFloatCz';

export default function getUsekQuantity(attributes) {
    let m2 = parseFloatCz(attributes.delka) * parseFloatCz(attributes.sirka);
    let m3 = m2 * (parseFloatCz(attributes.vyska_horni) + parseFloatCz(attributes.vyska_spodni)) / 2;
    let ks =  Math.trunc(parseFloatCz(attributes.delka) / parseFloatCz(attributes.rozestup)) || 1;
    return {
        m2,
        m3,
        ks
    };
}
